import Vue from 'vue'
import Router from 'vue-router'
import SubFrame from '@/components/SubFrame'
import MainFrame from '@/components/MainFrame'
import Login from '@/view/Login'
import ConfirmChangeEmail from '@/view/setting/ConfirmChangeEmail'
import Signup from '@/view/signup/Signup'
import Home from '@/view/home/Home'
import Notices from '@/view/Notices'
import Guide from '@/view/Guide'
import Setting from '@/view/setting/Setting'
import PaymentSuccessOrFail from '@/view/setting/PaymentSuccessOrFail'
import Revenue from '@/view/revenue/Revenue'
import ReqMoney from '@/view/revenue/ReqMoney'
import QuestionAnswer from '@/view/QuestionAnswer'
import Revdetail from '@/view/revdetail/Revdetail'
import Request from '@/view/request/Request'
import RequestComment from '@/view/request/RequestComment'
import Promotion from '@/view/promotion/Promotion'
import Affiliate from '@/view/affiliate/Affiliate'
import Sale from '@/view/sale/Sale'
import Analysis from '@/view/Analysis'
import Premium from '@/view/premium/Premium'
import SignupSuccess from '@/view/signup/SignupSuccess'
import ResetPassword from '@/view/resetpassword/ResetPassword'
import AcceptLicense from '@/view/AcceptLicense'
import ProductsNew from '@/view/productsNew/Products'
import DeliveryRequests from '@/view/deliveryRequests/DeliveryRequests'
import Warehouses from '@/view/warehouses/Warehouses'
import WarehouseCanceledPaymentMethod from '@/view/warehouses/CanceledRegisterPaymentMethod'
import WarehouseRegisteredPaymentMethod from '@/view/warehouses/RegisteredPaymentMethod'
import WarehouseAmazon from '@/view/warehouseAmazon/Warehouses'
import WarehouseAcross from '@/view/warehouseAcross/Warehouses'
import WarehouseSc from '@/view/warehouseSc/Warehouses'
import SalemonAgent from '@/view/salemonAgent/SalemonAgent'
import UpdateRegisterInfo from '@/view/updateRegisterInfo/UpdateRegisterInfo'
import PageNotFound from '@/components/PageNotFound'
import UpgradePlanCanceled from '@/view/setting/UpgradePlanCanceled'
import UpgradePlanCompleted from '@/view/setting/UpgradePlanCompleted'
import Video from '@/view/video/Video'
import VideoList from '@/view/video/VideoList'
import VideoPlayer from '@/view/video/VideoPlayer'
import store from '../store'
import MemberPlanService from '@/services/memberplanservice'

Vue.use(Router)
let storageSkipShowRegisterInfo = localStorage.getItem(`${store.getters.getUser.sellerId}-SkipShowRegisterInfo`)
this.ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.getStatus === '0') {
      next('/termsofservice')
      return
    }
    let screenWidth = $(window).width()
    if (screenWidth > 768) {
      let storageSideMenuClose = localStorage.getItem(`${store.getters.getUser.sellerId}-SideMenuClose`)
      if (storageSideMenuClose === 'true') {
        setTimeout(() => {
          const sideMenuSelector = $('.sidebar-menu')
          const menuSelector = $('#menu')
          const wrapperSelector = $('#wrapper')
          const itemMenuSelector = $('.item-menu')
          const iconToggleSideMenuSelector = $('.icon-toggle-side-menu')
          const fixedToggleSideMenuSelector = $('.fixed-toggle-side-menu')

          sideMenuSelector.addClass('sidebar-menu-close')
          fixedToggleSideMenuSelector.addClass('fixed-toggle-side-menu-close')
          menuSelector.addClass('menu-close')
          wrapperSelector.addClass('wrapper-side-menu-close')
          itemMenuSelector.children('span').addClass('menu-name-hidden')
          iconToggleSideMenuSelector.addClass('fa-caret-right')
        }, 300)
      }
    }
    let skipShowRegisterInfo = localStorage.getItem(`${store.getters.getUser.sellerId}-SkipShowRegisterInfo`)
    if (!store.getters.getUser.isSellerInfoUpdated && (skipShowRegisterInfo === 'false' || skipShowRegisterInfo === null)) {
      next('/update-register-info')
    } else {
      next()
    }
  } else {
    next(`/login?redirect=${to.fullPath}`)
  }
}

this.ifNotAuthenticated = (to, from, next) => {
  if (to.name === 'Login' && Object.keys(to.query).length && to.query.token) {
    next()
    return
  } else if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/home')
}

this.ifNotAcceptedLicense = (to, from, next) => {
  if (store.getters.getStatus === '0') {
    next()
    return
  }
  if (!store.getters.getUser.isSellerInfoUpdated && (storageSkipShowRegisterInfo === 'false' || storageSkipShowRegisterInfo === null)) {
    next('/update-register-info')
  } else {
    next('/home')
  }
}

this.ifNotUpdatedRegisterInfo = (to, from, next) => {
  if (!store.getters.getUser.isSellerInfoUpdated && (storageSkipShowRegisterInfo === 'false' || storageSkipShowRegisterInfo === null)) {
    next()
  }
  if (store.getters.getStatus === '0') {
    next('/termsofservice')
  }
  next()
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'SubFrame',
      component: SubFrame,
      redirect: 'login',
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
          beforeEnter: this.ifNotAuthenticated
        },
        {
          path: 'signup',
          name: 'Signup',
          component: Signup,
          beforeEnter: this.ifNotAuthenticated
        },
        {
          path: 'active',
          name: 'Signup success',
          component: SignupSuccess
        },
        {
          path: 'reset-password',
          name: 'Reset Password',
          component: ResetPassword
        },
        {
          path: 'termsofservice',
          name: 'Accept License',
          component: AcceptLicense,
          beforeEnter: this.ifNotAcceptedLicense
        },
        {
          path: 'not-found',
          name: 'NotFound',
          component: PageNotFound
        },
        {
          path: 'confirm-change-mail',
          name: 'ConfirmChangeMail',
          component: ConfirmChangeEmail
        },
        {
          path: 'guide',
          name: 'Guide',
          component: Guide
        },
        {
          path: 'update-register-info',
          name: 'UpdateRegisterInfo',
          component: UpdateRegisterInfo,
          beforeEnter: this.ifNotUpdatedRegisterInfo
        }
      ]
    },
    {
      path: '/',
      name: 'MainFrame',
      component: MainFrame,
      redirect: 'login',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: Home,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'delivery-requests/:tab',
          name: 'Delivery Requests',
          component: DeliveryRequests,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'delivery-requests',
          redirect: 'delivery-requests/top'
        },
        {
          path: 'warehouses',
          name: 'Warehouses',
          component: Warehouses,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'warehouse-amazon/:tab',
          name: 'Warehouse Amazon',
          component: WarehouseAmazon,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'warehouse-amazon',
          redirect: 'warehouse-amazon/top'
        },
        {
          path: 'warehouse-across/:tab/:subTab?',
          name: 'Warehouse across',
          component: WarehouseAcross,
          beforeEnter: this.ifAuthenticated,
          meta: {
            verifyPayment: (to) => true,
            defaultRedirectPath: '/warehouses'
          }
        },
        {
          path: 'warehouse-across',
          redirect: 'warehouse-across/top'
        },
        {
          path: 'warehouse-sc/:tab/:subTab?',
          name: 'Warehouse sc',
          component: WarehouseSc,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'warehouse-sc',
          redirect: 'warehouse-sc/top'
        },
        {
          path: 'salemon-agent/:tab',
          name: 'Salemon Agent',
          component: SalemonAgent,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'salemon-agent',
          redirect: 'salemon-agent/long-term-stock'
        },
        {
          path: 'warehouses/canceled-register-payment-method',
          name: 'Warehouse Canceled Register Payment Method',
          component: WarehouseCanceledPaymentMethod,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'warehouses/registered-payment-method',
          name: 'Warehouse Registered Payment Method',
          component: WarehouseRegisteredPaymentMethod,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'notices',
          name: 'Notices',
          component: Notices,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'setting/:tab',
          name: 'Setting',
          component: Setting,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'setting',
          redirect: 'setting/plan-info'
        },
        {
          path: 'payment',
          name: 'Paymen Announcement',
          component: PaymentSuccessOrFail,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'revenue',
          name: 'Revenue',
          component: Revenue,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'reqmoney',
          name: 'ReqMoney',
          component: ReqMoney
        },
        {
          path: 'quesanswer',
          name: 'Question Answer',
          component: QuestionAnswer,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'revdetail',
          name: 'Revdetail',
          component: Revdetail,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'request',
          name: 'Request',
          component: Request,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'request/comment/:id',
          name: 'RequestComment',
          component: RequestComment,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'sale/:tab/:saleId?',
          name: 'Sale',
          component: Sale,
          beforeEnter: this.ifAuthenticated,
          meta: {
            verifyPayment: (to) => {
              return to.params.tab === 'open' && to.params.saleId != null
            },
            defaultRedirectPath: '/sale/open'
          }
        },
        {
          path: 'sale',
          redirect: 'sale/open'
        },
        {
          path: 'affiliate/:tab',
          name: 'Affiliate',
          component: Affiliate,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'affiliate',
          redirect: 'affiliate/top'
        },
        {
          path: 'analysis/:id',
          name: 'Analysis',
          component: Analysis,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'premium/:tab?',
          name: 'Premium',
          component: Premium,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'promotion/:tab',
          name: 'Promotion',
          component: Promotion,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'promotion',
          redirect: 'promotion/top'
        },
        {
          path: 'products-new/:tab',
          name: 'ProductsNew',
          component: ProductsNew,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'products-new',
          redirect: 'products-new/list'
        },
        {
          path: 'upgrade-plan-completed',
          name: 'Upgrade plan premium completed',
          component: UpgradePlanCompleted,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: 'upgrade-plan-canceled',
          name: 'Canceled Upgrade Plan Premium',
          component: UpgradePlanCanceled,
          beforeEnter: this.ifAuthenticated
        },
        {
          path: '/video',
          component: Video,
          children: [
            {
              path: '',
              name: 'VideoList',
              component: VideoList,
              beforeEnter: this.ifAuthenticated
            },
            {
              path: ':id',
              name: 'VideoPlayer',
              component: VideoPlayer,
              beforeEnter: this.ifAuthenticated
            }
          ]
        }
      ]
    }
  ]
})
router.beforeEach(async (to, from, next) => {
  if (!to.matched.length) {
    next('/not-found')
  } else {
    if (to.meta.verifyPayment && to.meta.verifyPayment(to)) {
      const loader = Vue.prototype.$loading.show()
      try {
        const { data } = await MemberPlanService.checkPaymentMethod({redirectPath: from.name ? from.path : to.meta.defaultRedirectPath})
        store.commit('toggleVerifyPaymentModal', {
          show: !data.verifyPaymentMethod,
          verifyPaymentCheckoutUrl: data.verifyPaymentCheckoutUrl || '',
          paymentMethodRegistExp: data.paymentMethodRegistExp || '',
          paymentRedirectPath: from.name ? from.path : to.meta.defaultRedirectPath
        })
        if (!data.verifyPaymentMethod && from.name) {
          return
        }
      } catch (error) {
        console.log('error', error)
      } finally {
        loader.hide()
      }
    } else {
      store.commit('toggleVerifyPaymentModal')
    }
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js